"use strict";
exports.__esModule = true;
exports.Pagination = void 0;
var Pagination_1 = require("./Pagination");
var PaginationContext_1 = require("./PaginationContext");
var PaginationList_1 = require("./PaginationList");
var PaginationNextButton_1 = require("./PaginationNextButton");
var PaginationPrevButton_1 = require("./PaginationPrevButton");
var Pagination = Object.assign(Pagination_1.Pagination, {
    Context: PaginationContext_1.PaginationContext,
    PrevButton: PaginationPrevButton_1.PaginationPrevButton,
    NextButton: PaginationNextButton_1.PaginationNextButton,
    List: PaginationList_1.PaginationList
});
exports.Pagination = Pagination;
//# sourceMappingURL=index.js.map